import { render } from "./Exercise.vue?vue&type=template&id=43f0ff5e&scoped=true"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"

import "./Exercise.vue?vue&type=style&index=0&id=43f0ff5e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f0ff5e"]])

export default __exports__